import * as Yup from 'yup';

export default Yup.object().shape({
  name: Yup.string().required('Campo obrigatório'),
  username: Yup.string()
    .required('Campo obrigatório')
    .matches(
      /^[a-zA-Z0-9._-]+$/,
      'O login não pode conter espaços ou caracteres especiais'
    ),
  cpf: Yup.number().required('Campo obrigatório'),
  password: Yup.string().required('Campo obrigatório'),
});
